export const iconFontAwesomeHumanitarianShower = (
	<i className="fa-solid fa-shower"></i>
);
